import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../../../helpers";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { purchaseOrderStatus } from "../../../../../../localdata";
import {
  useGetPOCategories,
  useGetPurchaseOrders,
  useGetSuppliers,
} from "../../../../../../hooks/api/queries";
import { useEffect } from "react";

export const useAllPurchaseOrders = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
  } = useUrlSearch();

  const { isLoading: isLoadingPO, data } = useGetPurchaseOrders({ queries });
  const { data: suppliers, isLoading: isLoadingSupplier } = useGetSuppliers();
  const { data: pOCategories, isLoading: isLoadingPOCategories } =
    useGetPOCategories({});

  const closeNewPODialog = () => {
    search.delete("new_po_id");
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    if (!search.get("status")) filterByKey("status", "IN_REVIEW");
  }, []);

  return {
    isLoadingExtra: isLoadingSupplier || isLoadingPOCategories,
    isLoadingPO,
    purchaseOrders: data?.data,
    metaDetails: data?.meta,
    search,
    storeList,
    purchaseOrderStatus,
    suppliers: suppliers || [],
    pOCategories: pOCategories?.data || [],
    filterByDate,
    closeNewPODialog,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  };
};
